export type IScrollDirection = 'left' | 'right' | 'top' | 'bottom'

/**
 * 根据方向判断滚动的算法
 * @param direction 方向
 * @returns
 */
function checkScrollAlgorithm (direction: IScrollDirection) {
  switch (direction) {
    case 'left':
    case 'top':
      return 'minu'
    case 'right':
    case 'bottom':
      return 'plus'
  }
}

/**
 * 检查滚动方向
 * @param direction 方向
 * @returns
 */
function checkScrollMethod (direction: IScrollDirection) {
  switch (direction) {
    case 'left':
    case 'right':
      return 'scrollLeft'

    case 'top':
    case 'bottom':
      return 'scrollTop'
  }
}

/**
 * 滚动动画
 * @param opt 参数
 */
export function scrollAnimation (opt: { dom: HTMLElement, scroll: number, direction: IScrollDirection }) {
  let current = 0

  /* dom节点当前的滚动位置 */
  let currentDomScroll = 0

  const scrollMethod = checkScrollMethod(opt.direction)

  /* 根据方向获取dom节点当前的滚动位置 */
  currentDomScroll = opt.dom[scrollMethod]

  let scrollAnimation = 0

  function animation () {
    let scrollPow = currentDomScroll

    let finashScroll = currentDomScroll

    const algorithm = checkScrollAlgorithm(opt.direction)

    /* 根据方向判断加减 */
    switch (algorithm) {
      case 'minu':
        scrollPow -= Math.pow(current, 1.6)
        finashScroll -= opt.scroll
        break
      case 'plus':
        scrollPow += Math.pow(current, 1.6)
        finashScroll += opt.scroll
        break
    }

    if ((algorithm === 'plus' && scrollPow < finashScroll) || (algorithm === 'minu' && scrollPow > finashScroll)) {
      current++

      scrollAnimation = scrollPow

      setTimeout(() => {
        animation()
      })
    } else {
      scrollAnimation = finashScroll
    }

    opt.dom[scrollMethod] = scrollAnimation
  }

  animation()
}
